<template>
    <v-dialog v-model="dialog" width="250">
        <div class="d-flex flex-column justify-center align-center elevation-15 higlight-type-content ">
            <div
                class="d-flex flex-column justify-center align-center position-relative pa-10"
            >
                <div class="check-i-img d-flex flex-column justify-center align-center">
                    <img :src="usedImg" alt="pistas imagen de modal" />
                </div>
                <div class="py-3 d-flex flex-column justify-center align-center">
                    <span class="text-h6 primary--text">{{
                        $t('bookReading.highlight_saved')
                    }}</span>
                </div>
            </div>
        </div>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            usedImg: require('@/assets/img/icons/reading/highlight/icon-check.svg'),
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
    },
}
</script>
<style>

.check-i-img img{
    width: 10vh;
    height: 10vh;
}
.higlight-type-content {
    border-radius: 26px;
    background: #fff;
}
</style>
